/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Guide_S3_L2Inputs */

const en_landing_guide_s3_l2 = /** @type {(inputs: Landing_Guide_S3_L2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Packaging and labels: swap a flavour name or a weight on a jar or a bag while the product shot stays untouched.`)
};

const zh_landing_guide_s3_l2 = /** @type {(inputs: Landing_Guide_S3_L2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包装与标签：替换瓶身或袋子上的口味名称、净含量，产品图本身纹丝不动。`)
};

/**
* | output |
* | --- |
* | "Packaging and labels: swap a flavour name or a weight on a jar or a bag while the product shot stays untouched." |
*
* @param {Landing_Guide_S3_L2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_guide_s3_l2 = /** @type {((inputs?: Landing_Guide_S3_L2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Guide_S3_L2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_guide_s3_l2(inputs)
	return zh_landing_guide_s3_l2(inputs)
});
export { landing_guide_s3_l2 as "landing.guide.s3_l2" }